import { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GetAnnouncement } from '../../../model/datatype';
import Moment from 'moment';
import moment from 'moment-timezone';
import parse from 'html-react-parser';
export const AnouncementShow = (prop: any) => {
  const timezoneStr = Intl.DateTimeFormat().resolvedOptions().timeZone || 'FallbackTimeZone';
  let { t } = useTranslation();
  let location: any = useLocation();
  const [data, setData] = useState<GetAnnouncement | null>(null);
  const [desc, setDesc] = useState('');
  useEffect(() => {
    if (data === null) {
      setData(location.state);
    }
  }, [data]);

  if (localStorage.getItem('Language') === 'en') {
    Moment.locale('en-sg');
  } else {
    Moment.locale('th');
  }

  // console.log(data);
  const URL = 'data:image/jpg;base64,' + data?.thumnail;
  return (
    <>
      <Container className="anouncement-layout">
        <Row className="mb-3">
          <Col>
            <div className="anouncement-box">
              <div className="images">
                <img
                  src={URL}
                  alt=""
                  className="rounded img-thumbnail img-fluid w-100 max-h-auto"
                />
              </div>
              <div className="show-title px-3 fs-5">
                {localStorage.getItem('Language') === 'th'
                  ? data?.subjectTh
                  : data?.subjectEn}
              </div>
              <div className="date">
                <img src="../images/calendar-icon.svg" alt="" />
              </div>
              <div className="icon-date">
                {/* {Moment(data?.publishedDateTime).format('DD MMM YYYY HH:mm')}  */}
                {moment(data?.createdDateTime + 'Z')
                  .tz(timezoneStr)
                  .format('DD MMM YYYY')}
              </div>

              <div className="show-detail text-break mt-4 px-2 fs-6 m-2">
                {localStorage.getItem('Language') === 'th'
                  ? parse(location.state.detailsTh)
                  : parse(location.state.detailsEn)}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
